import useSWRMutation from 'swr/mutation'
import {fetcher, defaultHeaders} from '../../../api'
import {useRails} from '../../contexts/rails'

// Matches the entered account number against the supplier's connected accounting
// provider. When a match is found the backend records it as the reconciliation
// account and returns its id, letting the manual flow skip the reconciliation
// account screen. Returns {bank_account_id: <id|null>}.
const useMatchReconciliationAccount = () => {
  const {
    organisation: {currentSupplier},
    authenticityToken,
  } = useRails()

  const {trigger} = useSWRMutation(
    `/api/suppliers/${currentSupplier.id}/reconciliation_account/match`,
    async (url, {arg}) =>
      fetcher(url, {
        method: 'POST',
        headers: defaultHeaders({authenticityToken}),
        body: JSON.stringify({
          reconciliation_account: {
            bsb: arg.bsb,
            account_number: arg.accountNumber,
          },
        }),
      }),
    {revalidate: false, populateCache: false},
  )

  return {match: trigger}
}

export default useMatchReconciliationAccount
